import {AuthenticateModalProps} from "@Modals/authenticate-modal";
export type PromptSuggestionsValue = DefaultPromptSuggestions | RestaurantPromptSuggestions | EmailSingleRewrite;
export type PromptOptionValue = Mood | EmojiUsage | ImageModel;
export type SelectedPromptOptionValues = Record<PromptOption, PromptOptionValue>;
export type EditableComponentsMap = Partial<Record<EditableComponent, boolean>>;
export type PromptOptionsForEditableComponents = Partial<Record<EditableComponent, PromptOption[]>>;
export type PromptSuggestionsEnum = typeof DefaultPromptSuggestions | typeof RestaurantPromptSuggestions | typeof EmailSingleRewrite;

export interface OneOfPromptOption {
  option: PromptOption;
  value: PromptOptionValue;
}

export interface RedesignIssue {
  type: RedesignIssueType;
  icon: string;
  message: string;
}

export interface HeaderContent {
  title: string;
  icon: string;
  showPulsatingDot: boolean;
}

export interface UpsellDialogContent {
  dialogName: string;
  showDialog: boolean;
}

export interface CreditsPillContent {
  remainingCredits: number;
  actionCost: number;
}

export interface AuthenticateModalContent {
  showModal: boolean;
  modalProps: AuthenticateModalProps;
}

export interface AiRedesignPromptBoxProps {
  regenerateContent: (prompt: string, options: SelectedPromptOptionValues, editableComponentsMap?: EditableComponentsMap) => Promise<void>;
  placeholder: string;
  editableComponentsMap: EditableComponentsMap;
  promptOptionsForEditableComponents: PromptOptionsForEditableComponents;
  headerContent?: HeaderContent;
  promptSuggestions?: PromptSuggestions;
  defaultPrompt?: string;
  defaultSelectedPromptOptionValues?: SelectedPromptOptionValues;
  promptBoxClasses?: string;
  isPromptBoxLoading?: boolean;
  isPromptBoxSelectedOnRender?: boolean;
  redesignIssueOnRender?: RedesignIssue;
  onPromptChange?: (prompt: string) => void;
  onSelectedPromptOptionValuesChange?: (promptOptionValues: SelectedPromptOptionValues) => void;
  onEditableComponentsMapChange?: (editableComponentsMap: EditableComponentsMap) => void;
  onRedesignIssue?: (issue: RedesignIssue | undefined) => void;
  recentPrompt?: string;
  upsellDialog?:UpsellDialogContent;
  creditsPillContent?: CreditsPillContent;
  unselectOnOutsideClick?: boolean;
  showInitialAnimation?: boolean;
  authenticateModalContent?: AuthenticateModalContent;
}

export enum PromptOption {
  MOOD = 'mood',
  EMOJI_USAGE = 'emoji_usage',
  IMAGE_MODEL = 'image_model',
}

export enum Mood {
  Formal = 'formal',
  Bold = 'bold',
  Minimal = 'minimal',
  Elegant = 'elegant',
  Vibrant = 'vibrant',
  Modern = 'modern',
  Classic = 'classic',
  Creative = 'creative',
  Playful = 'playful',
  Sleek = 'sleek',
}

export enum EmojiUsage {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum ImageModel {
  Flux = 'flux',
  Stability = 'stability',
}

export enum PromptSuggestions {
  DEFAULT = 'default',
  RESTAURANT = 'restaurant',
  EMAIL_SINGLE_REWRITE = 'email_single_rewrite',
}

export enum DefaultPromptSuggestions {
  CHURCH_NEWLETTER = 'church_newletter',
  SALE = 'sale',
  RESTAURANT_DAILY_SPECIALS = 'restaurant_daily_specials',
  SCHOOL_NEWSLETTER = 'school_newsletter',
}

export enum RestaurantPromptSuggestions {
  CAFE_DAILY_SPECIALS = 'cafe_daily_specials',
  BAR_MENU = 'bar_menu',
  HAPPY_HOUR = 'happy_hour',
  COCKTAIL_HOUR = 'cocktail_hour',
}

export enum EmailSingleRewrite {
  CHURCH_EVEMTS = 'email_single_rewrite_church_events',
  SALE = 'email_single_rewrite_sale',
  SUNDAY_SERVICE = 'email_single_rewrite_sunday_service',
  DAILY_SPECIALS = 'email_single_rewrite_daily_specials',
}

export enum EditableComponent {
  TEXT = 'text',
  IMAGE = 'image',
}

export enum RedesignIssueType {
  ERROR = 'error',
  WARNING = 'warning',
}

export enum CreditsPillTheme {
  SECONDARY = 'secondary',
  WARNING = 'warning',
}

export enum PromptOptionSelectorLayoutType {
  PILLS = 'pills',
  CARDS = 'cards',
}

export enum ImageComponentType {
  IMAGE = 'image',
  BACKGROUND_IMAGE = 'background_image',
  DESIGN = 'design',
}